export default __webpack_public_path__ + "static/media/partner-USAID.57b94083.svg";